import superagent from 'superagent';

import { APP_ORIGIN_HEADER_KEY, APP_ORIGINS } from '@didaskill/domain/platform-constants';

const agent = superagent.agent();

agent.set(APP_ORIGIN_HEADER_KEY, APP_ORIGINS.BACKOFFICE);

export default agent;
